export default __webpack_public_path__ + "static/media/moldova1.b5929401.jpeg";